var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDndicon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 94,
  height: 66,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B9B9B9",
  d: "M79.406 28.856C77.366 12.793 63.614.333 47.001.333 34.139.333 22.967 7.851 17.867 19.7 7.843 22.696.334 32.16.334 42.333c0 12.866 10.467 23.334 23.333 23.334h51.334c10.294 0 18.666-8.372 18.666-18.667 0-8.773-6.09-16.156-14.261-18.144M51.667 42.333v14h-9.333v-14h-14L47.001 19l18.666 23.333z"
})));
export default SvgDndicon;